import React from "react";
import classNames from "classnames";
import style from "./EnhancedSearchSideBar.module.scss";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import ShowMoreButton from "./ShowMoreButton";

const SavedSearchResults = ({
                              recentSearches = {}, clearSearch = (searchKey) => {
  }
                            }) => {
  const showButtonIfTooManyResults = Object.keys(recentSearches).length > 10;
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  return (<div id="recentSearchDiv">
    <div>
      <div className={classNames("size-18", style.topicHeader)}>
        My saved searches
      </div>
      <ul className={classNames(style.recentSearches)}>
        {Object.keys(recentSearches)
          .slice(0, isCollapsed ? 10 : undefined)
          .map((searchKey, idx) => (
            <li key={idx} className={style.recentSearchItem}>
              <button className="tg-icons-Cross" aria-label={`Remove saved search: ${searchKey}`}
                      onClick={() => clearSearch(searchKey)}></button>
              <span><Link to={recentSearches[searchKey].searchQuery}
                          aria-label={`Saved Searches Item: ${searchKey}`}>{recentSearches[searchKey].searchLabel}</Link></span>
            </li>
          ))}
      </ul>
      {showButtonIfTooManyResults &&
        <ShowMoreButton isCollapsed={isCollapsed} onClick={() => setIsCollapsed(!isCollapsed)}/>}
    </div>
  </div>)
};

SavedSearchResults.propTypes = {
  recentSearches: PropTypes.objectOf(
    PropTypes.shape({
      searchQuery: PropTypes.string.isRequired,
      searchLabel: PropTypes.string.isRequired,
    })
  ),
  clearSearch: PropTypes.func,
};
export default SavedSearchResults;

